import { memo } from "react";
import widgetIcon from "/images/widget-icon.webp";
import closeIcon from "/images/close-icon.svg";
import { APP_NAME } from "@/configs/app";
interface ChatHeaderProps {
  onClose: () => void;
  agentState: string;
  isMicrophoneEnabled: boolean;
}

export const ChatHeader = memo(function ChatHeader({
  onClose,
  agentState,
  isMicrophoneEnabled,
}: ChatHeaderProps) {
  return (
    <div className="header flex items-center justify-between flex-shrink-0">
      <div className="flex items-center gap-[20px]">
        <div className="gradient-wrap w-[40px] h-[40px] bg-white rounded-[50%] p-[1.72px]">
          <div className="content flex items-center justify-center cursor-pointer">
            <img
              src={widgetIcon}
              alt="widget-icon"
              className="w-[21px] h-[20px]"
            />
          </div>
        </div>
        <p className="voice-chat_header-text text-[16px] leading-[150%]">
          {APP_NAME}
          <span
            style={{
              display: "none",
            }}
          >
            {agentState} / {isMicrophoneEnabled}
          </span>
        </p>
      </div>
      <a
        onClick={onClose}
        className="w-[40px] cursor-pointer h-[40px] rounded-[50%] flex items-center justify-center border-2 border-[#D8D8D8]"
      >
        <img
          src={closeIcon}
          alt="close-icon"
          className="w-[8.33px] h-[8.33px]"
        />
      </a>
    </div>
  );
});

